<template>
<b-container>
  <Loading v-if="item === undefined" />
  <Error v-else-if="item === null" code="404"></Error>
  <div v-else>
    <b-card class="mb-4" title="Location">
      <h2>{{item.name}}</h2>
      <p>Address: {{item.address_line_1}} {{item.address_line_2}} {{item.city}} {{item.postcode}}</p>
      <p>Contact: {{item.contact_first_name}} {{item.contact_last_name}} - {{item.contact_email}} - {{item.contact_phone}}</p>
    </b-card>

    <Campaigns class="mb-4" />
    <Links />
  </div>
</b-container>
</template>

<script>
/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */

import {
  db
} from '@/main.js'
import ItemMixin from "@/mixins/Item.js"
import api from '@/lib/api.js'
import Campaigns from '@/components/Campaigns.vue'
import Links from '@/components/Links.vue'

export default {
  name: 'location',
  mixins: [ItemMixin],
  components: {
    Campaigns,
    Links
  },
  firestore: function() {
    return {
      item: db.collection('site').doc(this.$route.params.site_id).collection(this.collection).doc(this.$route.params.id),
    }
  },
  data() {
    return {
      item: undefined,
      collection: 'location'
    }
  },
  metaInfo() {
    return {
      title: this.collection
    };
  },
}
</script>

<style>

</style>
